import { api } from "..";

export interface RevokeSessionElevationResponse {
  elevated: boolean;
}

export async function revokeSessionElevation(): Promise<RevokeSessionElevationResponse> {
  const res = await api.client.delete("/auth-new/elevate");
  return res.data;
}
